export default function UserPage() {
    return <></>;
}
